import React, { useState } from "react";
import { CSSTransition } from "react-transition-group";
import LinkHandler from "./LinkHandler";
import { Why } from "./Why"
import Timeline from "./Timeline";

export const About = (props) => {
  const [isImageVisible, setImageVisible] = useState(false);
  React.useEffect(() => {
    setImageVisible(true);
  }, []);

  return (
    <div className="about">
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-md-6">
            <CSSTransition
              in={isImageVisible}
              timeout={500}
              classNames="blur"
              unmountOnExit
            >
              <img
                src="static/img/about.webp"
                className="img-responsive"
                alt="Профессиональная реставрация металла от компании Lift Blesk с вниманием к деталям"
              />
            </CSSTransition>
          </div>
          <div className="col-xs-12 col-md-6">
            <div className="about-text">

              <h2>Наш подход к работе</h2>

              <div className="about-description">
                <p>«<LinkHandler href="/" title="Пролистать на главную (на самый верх)">Lift Blesk</LinkHandler>» – это не просто <LinkHandler href="/metal-restoration-services" title="Пролистать к разделу наших услуг">услуги реставрации</LinkHandler>, это внимание к деталям и стремление вернуть металлу его первозданный вид. Мы гордимся своей командой: опытными профессионалами, которые не только знают своё дело, но и искренне любят его!</p>

                <p>За годы работы в Санкт-Петербурге мы восстановили множество лифтовых кабин, порталов и других конструкций. Каждый клиент для нас особенный, и мы стремимся сделать процесс сотрудничества максимально удобным и прозрачным.</p>
              </div>

              <h3>Наши принципы:</h3>
              <ol>
                <li><strong>Качество без компромиссов</strong>. Каждая работа проходит тщательную проверку.</li>
                <li><strong>Индивидуальный подход</strong>. Учитываем все детали проекта, включая тип металла и характер повреждений.</li>
                <li><strong>Точность на каждом этапе</strong>. Уделяем внимание мельчайшим деталям, чтобы добиться безупречного результата.</li>
              </ol>

              <h3>Наши ценности:</h3>
              <ul>
                <li><strong>Ответственность</strong> за каждый выполненный проект.</li>
                <li><strong>Доверие</strong> клиентов и их удовлетворённость.</li>
                <li><strong>Совершенствование</strong> навыков – наша постоянная цель.</li>
              </ul>

              {/* <p>Мы верим, что в каждом проекте важны детали, а в каждой детали – наш профессионализм!</p> */}

              {/* <h3>Почему выбирают нас?</h3> */}
              {/* <Why /> */}

{/*               <p>Мы ценим каждого клиента и подходим к каждому проекту с особым вниманием. Восстановление лифтов и металлоконструкций для нас – это не просто работа, а искусство, где важна каждая деталь.</p> */}

{/*               <h3>Наша философия</h3>
              <p>Мы верим, что эстетика и долговечность должны идти рука об руку. Именно поэтому «ЛифтБлеск» создаёт решения, которые сохраняют свою красоту и функциональность долгие годы. Мы стремимся к совершенству и продолжаем совершенствовать наши методы, чтобы оставаться на шаг впереди.</p>
              <p>Присоединяйтесь к числу наших довольных клиентов – мы работаем для вас и вашего комфорта!</p> */}


              {/* <p>{props.data ? props.data.paragraph : "Загрузка..."}</p> */}

{/*               <h3>Почему выбирают нас?</h3>
              <div className="list-style">
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                    {props.data
                      ? props.data.Why.map((d, i) => (
                          <li key={`${d}-${i}`}>{d}</li>
                        ))
                      : "Загрузка..."}
                  </ul>
                </div>
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                    {props.data
                      ? props.data.Why2.map((d, i) => (
                          <li key={`${d}-${i}`}>{d}</li>
                        ))
                      : "Загрузка..."}
                  </ul>
                </div>
              </div> */}


            </div>
          </div>
        </div>
      </div>
      <Why />
      <Timeline />
    </div>
  );
};